<script setup lang="ts">
import { useRoute } from "vue-router";
import { ref } from "vue";

const route = useRoute();

const props = defineProps<{ name: string }>();

const source = ref<string>("");

const name = ref<string>();

source.value = `https://img.pptutor.com/pptutor/activity/${props.name}.jpg`;
</script>
<template>
  <div class="container">
    <img :src="source" alt="" />
  </div>
</template>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  img {
    display: block;
    // width: 100%;
    // height: 100%;
    width: 100vw;
    // height: 100vh;
  }
}
</style>
